module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/close.svg?c21c5ab0300f6ca91b5ec5874ddff5cf";